import { createApiClient } from './createApiClient';

const { VITE_MUSIC_API_BASE_URL: MUSIC_API_BASE_URL } = import.meta.env;

const apiBase = createApiClient({
  baseURL: MUSIC_API_BASE_URL as string,
  enableBlobUrlPreview: true,
});

export default apiBase;
